<template>
  <div id="posVisualConfig">
    <PageTitle :title="$t('pos_visual_config.title')" :subtitle="$t('pos_visual_config.subtitle')"></PageTitle>
    <PageContainer v-if="ready">
      <div class="header">
        <div class="header__title">{{$t('pos_visual_config.customer_display_header_title')}}</div>
        <div class="header__description">{{$t('pos_visual_config.customer_display_header_description')}}</div>
      </div>
      <div class="section">
        <div class="section__title">
          <span>{{$t('pos_visual_config.standby_image')}}</span>
          <Tooltip text="980 x 574 px"></Tooltip>
        </div>
        <div class="section__description">{{$t('pos_visual_config.select')}}</div>
        <BranchMediaSelector ref="standbyImageMediaSelector" image :selected="standbyImage" @changed="selectStandbyImage($event)"></BranchMediaSelector>
      </div>
      <div class="section">
        <div class="section__title">
          <span>{{$t('pos_visual_config.ordering_screen_banner')}}</span>
          <Tooltip text="190 x 574 px"></Tooltip>
        </div>
        <div class="section__description">{{$t('pos_visual_config.select')}}</div>
        <BranchMediaSelector ref="bannerImageMediaSelector" image :selected="orderingBanner" @changed="selectBannerImage($event)"></BranchMediaSelector>
      </div>
    </PageContainer>
    <PageFooter :mainAction="{action: savePosCssData, text: $t('save')}"></PageFooter>
  </div>
</template>

<script>
  import PageContainer from "@/components/PageContainer";
  import PageTitle from "@/components/PageTitle";
  import PageFooter from "@/components/PageFooter";
  import BranchMediaSelector from "@/components/branch/BranchMediaSelector.vue";
  import Tooltip from "@/components/tools/Tooltip";
  import {mapActions} from "vuex";

  export default {
    name: "posVisualConfig",
    components: { PageContainer, PageTitle, PageFooter, BranchMediaSelector, Tooltip },

    data() {
      return {
        cssData: null,
        standbyImage: null,
        orderingBanner: null,
        ready: false
      }
    },
    async mounted() {
      this.$store.state.pageTitleTranslationKey = "pos_visual_config.title";
      this.$store.state.pageIcon = "/icon/art.svg";
      await this.loadCompanyCssData();
      this.ready = true;
    },

    methods: {
      ...mapActions(["getCompany", "saveCompany"]),

      async loadCompanyCssData() {
        if (!this.$route.query.branch || !this.$route.query.company) {
          this.$router.push("/");
          return;
        }

        this.$store.commit("showSpinner", true);
        let response = await this.getCompany({
          branchId: this.$route.query.branch,
          companyId: this.$route.query.company,
          fallback: false
        });
        this.$store.commit("showSpinner", false);

        if (response) {
          if (response.posCssData) {
            this.cssData = response.posCssData;

            if (!this.cssData.secondaryDisplay) {
              this.cssData.secondaryDisplay = {
                standbyImages: null,
                orderingBanner: null
              }
            }
          } else {
            this.cssData = {
              secondaryDisplay: {
                standbyImage: null,
                orderingBanner: null
              }
            }
          }
          this.orderingBanner = this.cssData.secondaryDisplay.orderingBanner;
          this.standbyImage = this.cssData.secondaryDisplay.standbyImage;
        } else {
          toast(this.$t("error.no_server"), "error");
        }
      },
      async savePosCssData() {
        this.$store.commit("showSpinner", true);
        let response = await this.saveCompany({
          branchId: this.$route.query.branch,
          companyId: this.$route.query.company,
          data: {
            posCssData: this.cssData
          }
        });

        if (response) {
          toast(this.$t("branch.success"), "success");
        } else {
          toast(this.$t("error.no_server"), "error");
        }
        this.$store.commit("showSpinner", false);
      },
      selectStandbyImage(image) {
        this.standbyImage = image;
        this.cssData.secondaryDisplay.standbyImage = image;
        this.$refs.standbyImageMediaSelector.$forceUpdate();
        this.$forceUpdate();
      },
      selectBannerImage(image) {
        this.orderingBanner = image;
        this.cssData.secondaryDisplay.orderingBanner = image;
        this.$refs.bannerImageMediaSelector.$forceUpdate();
        this.$forceUpdate();
      },
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    padding-bottom: 20px;

    .header__title {
      font-weight: bold;
      font-size: 16px;
      color: #404040;
    }
    .header__description {
      padding-top: 10px;
      font-size: 14px;
      color: #808080;
    }
  }
  .section {
    padding-top: 20px;

    .section__title {
      display: flex;
      flex-direction: row;
      font-size: 14px;
      font-weight: 900;
      color: var(--primary-color);

      .tooltip {
        padding-left: 10px;
      }
    }
    .section__description {
      padding-top: 10px;
      font-size: 14px;
      color: #808080;
    }
    &:not(:first-of-type) {
      border-top: dashed 1px #e6e6e6;
    }
  }



</style>